<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12 md8>
        <v-alert :value="true" dense outlined type="error" v-if="error">
          {{ error }}
        </v-alert>
        <v-alert :value="true" dense outlined type="success" v-if="message">
          {{ message }}
        </v-alert>
        <v-form>
          <v-container py-0>
            <v-layout wrap>
              <v-flex xs12 md12 text-left><h4>Lisää uusi kysymys</h4></v-flex>
              <v-flex xs12 md12>
                <v-textarea
                  label="Kysymys"
                  prepend-icon="mdi-information-variant"
                  v-model="addQuestionValues.questionDescription"
                  autocomplete="off"
                  required
                />
              </v-flex>
              <v-flex xs12 md12>
                <v-autocomplete
                  prepend-icon="mdi-traffic-light"
                  v-model="addQuestionValues.questionGroup"
                  :items="questionGroups"
                  item-text="queryQuestionGroupName"
                  item-value="id"
                  label="Kysymys ryhmä"
                  placeholder="Valitse"
                  required
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 md12>
                <v-autocomplete
                  prepend-icon="mdi-traffic-light"
                  v-model="addQuestionValues.questionState"
                  :items="questionState"
                  item-text="name"
                  item-value="value"
                  label="Kysymyksen tila"
                  placeholder="Valitse"
                  required
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 text-xs-right>
                <v-btn
                  class="mx-0 font-weight-light"
                  color="general"
                  @click.prevent="addNewQuestion"
                >
                  Lisää uusi kysely
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import QuestionService from '@/services/PowerGuard/QuestionService.js';
import QuestionGroupService from '@/services/PowerGuard/QuestionGroupService.js';
export default {
  data() {
    return {
      questionState: [
        { name: 'Aktiivinen', value: 'active' },
        { name: 'Passiivinen', value: 'passive' },
      ],
      addQuestionValues: {},
      questionGroups: [],
      message: null,
      error: null,
      rules: {
        required: (value) => !!value || 'Pakollinen tieto',
      },
    };
  },
  async created() {
    try {
      const response = await QuestionGroupService.getAllQuestionGroups();
      this.questionGroups = response.data.groups;
    } catch (error) {
      this.error = error;
    }
  },

  methods: {
    async addNewQuestion() {
      try {
        console.log(this.addQuestionValues);
        const response = await QuestionService.addNewQuestion(
          this.addQuestionValues
        );
        this.addQuestionValues = {};
        this.message = response.data.message;
        this.error = response.error;
        setTimeout(() => {
          this.error = null;
          this.message = null;
        }, 3000);
      } catch (error) {
        this.error = error.response.data.error;
        setTimeout(() => {
          this.error = null;
        }, 3000);
      }
    },
  },
};
</script>
